import React from 'react';
import { Dropdown, Menu } from 'antd';
import {
    EyeOutlined,
    EditOutlined,
    SyncOutlined,
    UserAddOutlined,
    PlusOutlined,
    SwapOutlined,
    LinkOutlined,
    DeleteOutlined,
    CheckCircleOutlined,
} from '@ant-design/icons';

export default function WorkItemContextMenu({
    children,
    item,
    onView,
    onEdit,
    onStatusChange,
    onAssign,
    onAddSubtask,
    onConvertType,
    onDelete,
}) {
    if (!item) return children;

    const isMilestone = item.itemType === 'milestone';

    const items = isMilestone
        ? [
            {
                key: 'view',
                icon: <EyeOutlined />,
                label: 'View Milestone',
                onClick: () => onView?.(item),
            },
            {
                key: 'edit',
                icon: <EditOutlined />,
                label: 'Edit Milestone',
                onClick: () => onEdit?.(item),
            },
            {
                key: 'div-1',
                type: 'divider',
            },
            {
                key: 'add-task',
                icon: <PlusOutlined />,
                label: 'Add Child Task',
                onClick: () => onAddSubtask?.(item),
            },
            {
                key: 'complete',
                icon: <CheckCircleOutlined className="text-emerald-500" />,
                label: <span className="font-semibold text-emerald-700 dark:text-emerald-400">Mark as Completed</span>,
                onClick: () => onStatusChange?.(item._id, 'Completed'),
            },
            {
                key: 'convert',
                icon: <SwapOutlined className="text-amber-500" />,
                label: <span className="font-semibold text-amber-700 dark:text-amber-300">Convert to Task</span>,
                onClick: () => onConvertType?.(item),
            },
            {
                key: 'div-2',
                type: 'divider',
            },
            {
                key: 'delete',
                icon: <DeleteOutlined className="text-red-500" />,
                label: <span className="text-red-600">Archive / Delete</span>,
                onClick: () => onDelete?.(item._id),
            },
        ]
        : [
            {
                key: 'view',
                icon: <EyeOutlined />,
                label: 'View Task',
                onClick: () => onView?.(item),
            },
            {
                key: 'edit',
                icon: <EditOutlined />,
                label: 'Edit Task',
                onClick: () => onEdit?.(item),
            },
            {
                key: 'div-1',
                type: 'divider',
            },
            {
                key: 'add-subtask',
                icon: <PlusOutlined />,
                label: 'Add Subtask',
                onClick: () => onAddSubtask?.(item),
            },
            {
                key: 'complete-task',
                icon: <CheckCircleOutlined className="text-emerald-500" />,
                label: <span className="font-semibold text-emerald-700 dark:text-emerald-400">Mark as Completed</span>,
                onClick: () => onStatusChange?.(item._id, 'Completed'),
            },
            {
                key: 'convert',
                icon: <SwapOutlined className="text-[#03488a]" />,
                label: <span className="font-semibold text-[#03488a] dark:text-[#a7c8ff]">Convert to Milestone</span>,
                onClick: () => onConvertType?.(item),
            },
            {
                key: 'div-2',
                type: 'divider',
            },
            {
                key: 'delete',
                icon: <DeleteOutlined className="text-red-500" />,
                label: <span className="text-red-600">Archive / Delete</span>,
                onClick: () => onDelete?.(item._id),
            },
        ];

    return (
        <Dropdown menu={{ items }} trigger={['contextMenu']}>
            <div className="w-full flex items-center">{children}</div>
        </Dropdown>
    );
}
